import allocations from '../assets/module-icons/allocations.svg';
import inventory from '../assets/module-icons/inventory.svg';
import planningAssistant from '../assets/module-icons/planning-assistant.svg';
import purchasing from '../assets/module-icons/purchasing.svg';
import replenishment from '../assets/module-icons/replenishment.svg';
import specialEvents from '../assets/module-icons/special-events.svg';
import storeTransfer from '../assets/module-icons/store-transfer.svg';
import analytics from '../assets/module-icons/analytics.svg';
import automations from '../assets/module-icons/automations.svg';
import { ModuleNames } from './module-names';
import { getModuleImage } from './sheets';

const ceoPanelIcon = getModuleImage('ceo-panel') || analytics;
const cfoPanelIcon = getModuleImage('cfo-panel') || analytics;
const cooPanelIcon = getModuleImage('coo-panel') || analytics;
export default {
  [ModuleNames.Allocations]: allocations,
  [ModuleNames.Analytics]: analytics,
  [ModuleNames.Inventory]: inventory,
  [ModuleNames.Purchasing]: purchasing,
  [ModuleNames.Replenishment]: replenishment,
  [ModuleNames.SpecialEvents]: specialEvents,
  [ModuleNames.StoreTransfer]: storeTransfer,
  [ModuleNames.PlanningAssistant]: planningAssistant,
  [ModuleNames.DataCenter]: null,
  [ModuleNames.CfoPanel]: cfoPanelIcon,
  [ModuleNames.CeoPanel]: ceoPanelIcon,
  [ModuleNames.CcoPanel]: cooPanelIcon,
  [ModuleNames.Liquidation]: inventory,
  [ModuleNames.OtbExecution]: purchasing,
  [ModuleNames.RulesEngine]: automations,
};
